import React from 'react'
import { Alert } from 'components'

const ExistAssessmentAlert = (props) => {
    const { accept, close } = props

    const footerActions = React.useMemo(
        () => [
            { label: "יציאה ומחיקה", variant: "danger", color: "error", action: accept },
            { label: "ביטול", variant: "white", color: "thirdly4", action: close },
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={"האם את בטוחה שאת רוצה לצאת מהמבדק?"}
            footerActions={footerActions}
            handleAlert={close}
        >
            {"יציאה מהמבדק תגרום לאפוס המבדק."}
        </Alert>
    )
}

export default ExistAssessmentAlert